export const userAccountTracker = {
  events: {
    accessMyAccount: 'Acessar Minha Conta',
  },
}
